import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import AddTitlePanel from './AddTitlePanel';

class UploadDialogCtrl extends Component<any, any> {
    public transitionTime: number;
    constructor(props) {
        super(props);
        this.transitionTime = 300;
        this.state = { dialogs: [] };
    }

    addDialog(dialog) {
        const dialogItem = [];
        dialogItem.push(dialog);
        if (dialog) {
            this.setState({ dialogs: dialogItem });
        }
        return () => {
            this.removeDialog();
        };
    }

    public removeDialog = (): void => {
        this.setState({
            dialogs: [],
        });
    };

    render() {
        const { dialogs } = this.state;
        return (
            <TransitionGroup className="Dialog-panel-container">
                {dialogs.map((dialog, idx) => (
                    <CSSTransition
                        key={idx}
                        classNames="Dialog-panel-wrapper dialog"
                        timeout={this.transitionTime}>
                        <AddTitlePanel
                            {...dialog}
                            removeDialog={this.removeDialog}
                        />
                    </CSSTransition>
                ))}
            </TransitionGroup>
        );
    }
}

function createNotification() {
    const div = document.createElement('div');
    document.body.appendChild(div);
    const ref = React.createRef<TransitionGroup>();
    ReactDOM.render(<UploadDialogCtrl ref={ref} />, div);
    return {
        addDialog(dialog) {
            return ref.current.addDialog(dialog);
        },
        destroy() {
            ReactDOM.unmountComponentAtNode(div);
            document.body.removeChild(div);
        },
    };
}

export default createNotification();
